import React from "react";
import {Box, Typography} from "@mui/material";

export default function Sparkline({data = [], height = 36, strokeWidth = 2, width = 120}) {
    if (!data.length) {
        return (
            <Box sx={{width, height, display: "flex", alignItems: "center", color: "text.disabled"}}>
                <Typography variant="caption">keine Daten</Typography>
            </Box>
        );
    }
    const max = Math.max(...data);
    const min = Math.min(...data);
    const norm = (value) => {
        if (max === min) return height / 2;
        return height - ((value - min) / (max - min)) * (height - strokeWidth) - strokeWidth / 2;
    };
    const step = width / Math.max(1, data.length - 1);
    const path = data
        .map((value, idx) => `${idx === 0 ? "M" : "L"} ${idx * step},${norm(value)}`)
        .join(" ");
    return (
        <svg width={width} height={height} aria-hidden>
            <path d={path} fill="none" stroke="currentColor" strokeWidth={strokeWidth}/>
        </svg>
    );
}
